import { dataHooks } from '@wix/data-hooks'

export const wixStudioWelcomeDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  skip: {}
  item: { key: string }
  link: {}
  sidePanel: {}
  sidePanelAnimation: {}
  disclaimer: {}
}>('wix-studio-welcome')
